{
  "overridesEnabledBadgeLabel": "覆寫已開啟"
}
